import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8cc88476"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "话题封面", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "posn_icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icons_po iconfont iconyy-tishi"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "icons_po"
}, "比例1:1，大小不超过2M")], -1));
const _hoisted_3 = {
  class: ""
};
const _hoisted_4 = {
  key: 1,
  class: "boxs"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { addCaseTopicApi } from "@/service/modules/case";
export default /*#__PURE__*/_defineComponent({
  __name: 'topic-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "add"
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const subBtnLoading = ref(false);
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "新增话题";
      } else if (props.dialogType === "edit") {
        return "编辑话题";
      }
    });
    const emit = __emit;
    const formRef = ref();
    const rules = {
      name: [{
        required: true,
        message: "请输入名称",
        trigger: "blur"
      }],
      img: [{
        required: true,
        message: "请上传图片",
        trigger: "blur"
      }]
    };
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      formRef.value?.resetFields();
      emit("closeDialog");
    }
    const form = reactive({
      id: null,
      name: "",
      img: ""
    });
    function restForm() {
      form.id = null;
      form.name = "";
      form.img = "";
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      if (props.dialogType === "add") {
        delete form.id;
      }
      let query = JSON.parse(JSON.stringify(form));
      try {
        let res = await addCaseTopicApi(query);
        ElMessage.success(props.dialogType === "add" ? "添加成功" : "修改成功");
        restForm();
        formRef.value?.resetFields();
        emit("restData");
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(() => {
          if (props.dialogType === "edit") {
            for (let key in form) {
              form[key] = props.itemData[key];
            }
          }
        });
      }
    });
    function imgTypeError() {
      ElMessage.warning("仅支持jpg/jpeg/png格式图片");
    }
    function imgLoadSuccess(img) {
      form.img = img;
    }
    function del_img() {
      form.img = "";
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_separate_upload = _resolveComponent("separate-upload");
      const _component_Close = _resolveComponent("Close");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "20%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "分类名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              maxlength: "5",
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "img",
            class: "img_box"
          }, {
            label: _withCtx(() => [_hoisted_1]),
            default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_2, _createElementVNode("div", _hoisted_3, [!form.img ? (_openBlock(), _createBlock(_component_separate_upload, {
              key: 0,
              maxSize: 2,
              accept: ".jpg, .png, .jpeg",
              "file-types": ['image/png', 'image/jpeg'],
              onTypeError: imgTypeError,
              onUploadSuccess: _cache[1] || (_cache[1] = $event => imgLoadSuccess($event))
            })) : _createCommentVNode("", true), form.img ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
              class: "images_x",
              src: form.img,
              alt: ""
            }, null, 8, _hoisted_5), _createVNode(_component_el_icon, {
              size: "20",
              onClick: del_img,
              color: "#fff",
              class: "icons"
            }, {
              default: _withCtx(() => [_createVNode(_component_Close)]),
              _: 1
            })])) : _createCommentVNode("", true)])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});